import React from 'react';

export default {
  svg: (
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#222"
        strokeWidth={2}
        strokeLinecap="square"
        d="m2.676 17.921 10.01-15.233 10.01 15.233 7.98-15.233"
      />
      <ellipse fill="#222" cx={2.716} cy={18.351} rx={2.716} ry={2.649} />
      <ellipse stroke="#222" fill="#222" cx={30.284} cy={2.649} rx={2.216} ry={2.149} />
      <ellipse fill="#222" cx={22.716} cy={18.351} rx={2.716} ry={2.649} />
      <ellipse stroke="#222" fill="#222" cx={12.824} cy={2.649} rx={2.216} ry={2.149} />
    </g>
  ),
  viewBox: '0 0 33 21'
};
